import { render, staticRenderFns } from "./ButtonsComponents.vue?vue&type=template&id=b0d1a8fe&"
import script from "./ButtonsComponents.vue?vue&type=script&lang=js&"
export * from "./ButtonsComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports